import React from 'react'
import { Field, reduxForm } from 'redux-form'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'

const renderCheckboxField = ({
	label,
	input,
	meta: { touched, invalid, error },
	inputLabelProps,
	inputProps,
	style,
	fullWidth,
	margin,
	variant,
	type,
	name,
	...custom
}) => {
	return (
		<FormGroup row>
			<FormControlLabel
				data-testid='wrapper-checkbox'
				control={<Checkbox color="primary" checked={input.value ? true : false} onChange={input.onChange} />}
				label={label}
				style={{ marginLeft: '0' }}				
				labelPlacement="end"
				name={name}
			/>
		</FormGroup>
	)
}

export default ({ label, name, inputLabelProps, inputProps, style, fullWidth, margin, variant, type, validators }) => (
	<Field
		data-testid='wrapper-checkbox-field'
		name={name}
		component={renderCheckboxField}
		label={label}
		inputLabelProps={inputLabelProps}
		inputProps={inputProps}
		style={style}
		fullWidth
		margin={margin}
		variant={variant}
		type={type}
		validate={validators}
	/>
)
